import React from "react"
import PropTypes from "prop-types";
import { StaticQuery, graphql } from "gatsby"

import CardLayout from './layouts/CardLayout'
import ListLayout from './layouts/ListLayout'
import PrevNextLayout from './layouts/PrevNextLayout'

function PostGrid(props) {
  const { layout } = props
  
  if (layout === 'list') {
    return <ListLayout {...props} />
  }

  if (layout === 'prevnext') {
    return <PrevNextLayout {...props} />
  }

  return <CardLayout {...props} />
}

export default props => {
  const {
    numPosts,
    category,
    currentPostPath,
    layout
  } = props

  return (
    <StaticQuery
      query={graphql`
        query {
          allBlogPosts: allFile(filter: {internal: {mediaType: {eq: "text/markdown"}}, , childMarkdownRemark: {frontmatter: {draft: {eq: false}}}}) {
            edges {
              node {
                id
                childMarkdownRemark {
                  frontmatter {
                    title
                    path
                    subtitle
                    coverPhoto
                    category
                    publishDate
                  }
                }
              }
            }
          }
          allBlogPostImages: allFile(filter: {relativeDirectory: {eq: "images"}, sourceInstanceName: {eq: "posts"}}) {
            nodes {
              relativePath
              childImageSharp {
                fluid(maxWidth: 1000) {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
          }
        }
      `}
      render={data => {
        let edges = data.allBlogPosts.edges

        // Raise Error if one post doesn't have a cover photo
        const coverPhotoSearchRes = edges.findIndex(
          edge => edge.node.childMarkdownRemark.frontmatter.coverPhoto === null
        )

        if (coverPhotoSearchRes !== -1) {
          throw Error(`A post doesn't have a cover photo. Post Title: ${edges[coverPhotoSearchRes].node.childMarkdownRemark.frontmatter.title}`)
        }

        // Raise Error if one post doesn't have a category
        const categorySearchRes = edges.findIndex(
          edge => edge.node.childMarkdownRemark.frontmatter.category === null
        )

        if (categorySearchRes !== -1) {
          throw Error(`A post doesn't have a category. Post Title: ${edges[categorySearchRes].node.childMarkdownRemark.frontmatter.title}`)
        }

        // Limit number of posts
        if (numPosts !== undefined) {
          edges = edges.slice(0, numPosts)
        }

        // Apply category filter
        if (category !== undefined) {
          edges = edges.filter(
            edge => edge.node.childMarkdownRemark.frontmatter.category === category
          )
        }

        // Do not include current post
        if (currentPostPath !== undefined && layout !== "prevnext") {
          edges = edges.filter(
            edge => edge.node.childMarkdownRemark.frontmatter.path !== currentPostPath
          )
        }
        
        // Sort by publish date
        edges.map(edge => {
          edge.publishDate = new Date(edge.node.childMarkdownRemark.frontmatter.publishDate)
          
          return edge
        })

        edges.sort((a, b) => b.publishDate - a.publishDate)

        return <PostGrid edges={edges} imageNodes={data.allBlogPostImages.nodes} {...props} />
      }}
    />
  )
}


PostGrid.defaultProps = {
  layout: 'default',
  currentPostPath: undefined,
  category: undefined,
  showImage: true,
  showSubtitle: true,
  numPosts: undefined,
};

PostGrid.propTypes = {
  layout: PropTypes.oneOf(['default', 'list', 'prevnext']),
  currentPostPath: PropTypes.string,
  category: PropTypes.string,
  showImage: PropTypes.bool,
  showSubtitle: PropTypes.bool,
  numPosts: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
